import { Page, DataTable } from "@shopify/polaris";
import usePaymentData from "../../../../hook/usePaymentData";
import { extractHour } from "../TotalSummary/TotalSummary";
import { DebitSummaryContainer } from "./DebitSummary.styles";

export function DebitSummary() {
  const { totalDebit } = usePaymentData();

  const rows = (totalDebit || []).map((payment) => [
    extractHour(payment.createdAt),
    `R$${(payment.amountCents / 100).toFixed(2)}`,
    payment.aut || "-",
    payment.wasConciliation ? "Sim" : "Não",
    payment.orderName || "-",
  ]);

  let totalAmountCents = 0;

  for (const payment of totalDebit || []) {
    const amountCents = parseInt(payment.amountCents, 10) || 0;
    totalAmountCents += amountCents;
  }

  const totalDebitFormatted = `R$${(totalAmountCents / 100).toFixed(2)}`;

  return (
    <DebitSummaryContainer>
      <Page title="Débito">
        <DataTable
          showTotalsInFooter
          truncate
          fixedFirstColumns
          columnContentTypes={[
            "text",
            "numeric",
            "numeric",
            "text",
            "numeric",
            "numeric",
          ]}
          headings={["Hora", "Valor", "AUT", "Avulso", "Pedido"]}
          rows={rows}
          totals={["", totalDebitFormatted, "", "", ""]}
          totalsName={{
            singular: "Total",
          }}
        />
      </Page>
    </DebitSummaryContainer>
  );
}
